import React from 'react';
import { Modal, Button, Spin } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

class Hospital extends React.Component {
    state = {
        visible: false,
        loading: false,
        data: {},
    }

    show = (hospitalId) => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData(hospitalId);
        });
    }

    loadData = (hospitalId) => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.hospital.list,
            data: {
                hospitalId,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res && res.datas && res.datas.length > 0 ? res.datas[0] : {},
                });
            },
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, loading, data } = this.state;
        const { hospitalName, hospitalLevel, hospitalProvince, hospitalCity, hospitalAddress, remark } = data;
        return (
            <Modal
                title="医院信息"
                visible={visible}
                onCancel={this.hide}
                className="create-modal"
                width="500px"
                maskClosable={false}
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div className="modal-content">
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">医院名称：</div>
                                <div className="item-right">{hospitalName}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">医院类型：</div>
                                <div className="item-right">{hospitalLevel}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">所在省份\直辖市：</div>
                                <div className="item-right">{hospitalProvince}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">所在城市：</div>
                                <div className="item-right">{hospitalCity}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">详细地址：</div>
                                <div className="item-right">{hospitalAddress}</div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">备注：</div>
                                <div className="item-right">{remark}</div>
                            </li>
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Hospital;



// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/components/Hospital.js